export default function VideoCameraIcon() {
  return (
    <>
      <path
        d='M19 68.8H50.8C57.9 68.8 63.7 63.5 64.7 56.7L78.9 65.8C79.7 66.3 80.5 66.6 81.4 66.6C82.2 66.6 82.9 66.4 83.6 66C85.1 65.2 86.1 63.5 86.1 61.8V28C86.1 26.2 85.1 24.6 83.6 23.8C82.1 23 80.3 23 78.9 24L64.7 33.1C63.8 26.3 57.9 21 50.8 21H19C11.3 21 5 27.3 5 35V54.9C5 62.5 11.2 68.8 19 68.8ZM81 27.3C81.3 27.1 81.5 27.2 81.6 27.3C81.7 27.4 82 27.6 82 28V61.8C82 62.2 81.7 62.4 81.6 62.5C81.4 62.6 81.2 62.6 81 62.5L64.8 52V37.8L81 27.3ZM9 35C9 29.5 13.5 25 19 25H50.8C56.3 25 60.8 29.5 60.8 35V54.9C60.8 60.4 56.3 64.9 50.8 64.9H19C13.5 64.9 9 60.4 9 54.9V35Z'
        fill='#38383A'
        stroke='#FBF3F2'
      />
    </>
  );
}
